<div class="dashboard-container">
    <header class="dashboard-header">
        <app-header class="header-full-width" [title]="title"></app-header>
    </header>
    <div class="dashboard-main">
        <mat-sidenav-container class="dashboard-sidenav-container">
            <mat-sidenav mode="side" opened class="dashboard-sidenav">
                <div>
                    <div>
                        <div class="selectionLabel">Customer</div>
                        <button class="nav-button" mat-button [matMenuTriggerFor]="customerMenu">
                            {{currentCustomer?.name}}
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                        <mat-menu class="menu-container" #customerMenu="matMenu">
                            @for ( customer of customers; track customer.id ) {
                            <button mat-menu-item class="menu-button" (click)="onCustomerChange(customer)">
                                {{customer.name}}
                            </button>
                            }
                        </mat-menu>
                    </div>

                    <div>
                        <div class="selectionLabel">Facility</div>
                        <button class="nav-button" mat-button [matMenuTriggerFor]="facilityMenu">
                            {{currentFacility?.name}}
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                        <mat-menu class="menu-container" #facilityMenu="matMenu">
                            @for ( facility of facilities; track facility.id ) {
                            <button mat-menu-item class="menu-button" (click)="onFacilityChange(facility)">
                                {{facility.name}}
                            </button>
                            }
                        </mat-menu>
                    </div>
                    <div>
                        <div class="selectionLabel">Reporting Year</div>
                        <button class="nav-button" mat-button [matMenuTriggerFor]="yearMenu">
                            {{currentYear}}
                            @if (isCurrentYearClosed) {
                                <mat-icon class="year-lock-icon">lock</mat-icon>
                            }
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                        <mat-menu class="menu-container" #yearMenu="matMenu">
                            @for ( period of currentReportingPeriods; track period ) {
                            <button mat-menu-item (click)="onYearChange(period.year)">
                                {{period.year}}
                                @if (period.status !== MasterReportingPeriodStatus.Active) {
                                    <mat-icon class="year-lock-icon year-lock-icon-with-margin">lock</mat-icon>
                                }
                            </button>
                            }

                        </mat-menu>

                    </div>
                </div>
                <hr/>
                <mat-nav-list>
                    @for (item of navItems; track $index) {
                    <a mat-list-item class="nav-link" [routerLink]="item.path" #link="routerLinkActive" routerLinkActive
                        [activated]="link.isActive"
                        [class.disabled]="(shouldDisableNavigation || item.enabled === false) && !item.alwaysEnabled"
                        [matTooltip]="item.tooltip || ''"
                        [matTooltipDisabled]="!item.tooltip"
                        (click)="(shouldDisableNavigation || item.enabled === false) && !item.alwaysEnabled && $event.preventDefault()">
                        {{ item.title }}
                    </a>
                    @if (item.children) {
                    <mat-nav-list>
                        @for (child of item.children; track $index) {
                        <a mat-list-item class="child-link" [routerLink]="child.path" #childLink="routerLinkActive"
                            routerLinkActive [activated]="childLink.isActive"
                            [class.disabled]="shouldDisableNavigation || child.enabled === false"
                            (click)="shouldDisableNavigation && $event.preventDefault()">
                            {{ child.title }}
                        </a>
                        }
                    </mat-nav-list>
                    }
                    }
                </mat-nav-list>
            </mat-sidenav>
            <mat-sidenav-content class="dashboard-content">
                @if (isFacilitySwitchLoading) {
                <div class="subscription-overlay">
                    <div class="subscription-message">
                        <mat-icon class="warning-icon loading-icon">sync</mat-icon>
                        <h2>Loading Facility</h2>
                        <p>Applying your facility selection and loading reporting data.</p>
                        <p class="help-text">This should only take a moment.</p>
                    </div>
                </div>
                }

                @if (showFacilityLoadErrorOverlay) {
                <div class="subscription-overlay">
                    <div class="subscription-message">
                        <mat-icon class="warning-icon error-icon">error_outline</mat-icon>
                        <h2>Facility Could Not Be Loaded</h2>
                        <p>{{ facilityLoadErrorMessage }}</p>
                        <div class="overlay-actions">
                            <button mat-raised-button color="primary" (click)="retryFacilityLoad()">
                                <mat-icon>refresh</mat-icon>
                                Retry
                            </button>
                        </div>
                        <p class="help-text">You can also choose a different customer, facility, or reporting year from the left menu.</p>
                    </div>
                </div>
                }

                <!-- Unpaid Subscription Overlay -->
                @if (showSubscriptionOverlay) {
                <div class="subscription-overlay">
                    <div class="subscription-message">
                        <mat-icon class="warning-icon">warning</mat-icon>
                        <h2>Subscription Required</h2>
                        <p>This facility has not been purchased for the {{ currentYear }} reporting year.</p>
                        <p>Please purchase a subscription to access the portal features.</p>
                        <button mat-raised-button color="primary" (click)="navigateToPurchase()">
                            <mat-icon>shopping_cart</mat-icon>
                            Purchase Subscription
                        </button>
                        <p class="help-text">You can still change the facility or year using the dropdowns above.</p>
                    </div>
                </div>
                }
                
                <!-- Main content here -->
                <div class="dashboard-scrollable-content" [class.content-hidden]="shouldHideContent">
                    <router-outlet></router-outlet>
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>
</div>